import { HtmlLabelCheckbox } from "@pjs/core-ui";
import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";

angularAMD.component("htmlLabelCheckbox", react2angular(HtmlLabelCheckbox, ["label", "isChecked", "isDisabled", "isRequired", "onChange"]));
